import React from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';

const Privacy = () => {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Navbar />
      <div className="flex-1 container mx-auto px-6 py-16 max-w-4xl">
        <h1 className="text-4xl font-black text-gray-900 mb-8 font-kannada">Privacy Policy (ಗೌಪ್ಯತಾ ನೀತಿ)</h1>
        <div className="space-y-6 text-gray-600 font-medium">
          <p>Welcome to **Kallina Koogu**. We value your privacy and are committed to protecting your personal data.</p>
          
          <h2 className="text-xl font-bold text-gray-900">1. Data Collection</h2>
          <p>We use standard analytics tools (like PostHog) to monitor website traffic. This helps us understand which news editions are most read in Chitradurga District.</p>

          <h2 className="text-xl font-bold text-gray-900">2. Cookies</h2>
          <p>We use essential cookies to remember your language settings (Kannada/English). Our advertisers may also use cookies to show you relevant local ads.</p>

          <h2 className="text-xl font-bold text-gray-900">3. Information for Advertisers</h2>
          <p>When you click on an advertisement, you are redirected to a third-party site. We do not share your personal identification with these advertisers.</p>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Privacy;
